import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ProjectRoutingModule } from './project-routing.module';
import { NewProjectComponent } from './new/new-project.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { BasicInfoComponent } from './new/basic-info/basic-info.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EditProjectComponent } from './edit/edit-project.component';
import { PicturesComponent } from './edit/pictures/pictures.component';
import { FloorPlanComponent } from './edit/floor-plan/floor-plan.component';
import { AttachmentsComponent } from './edit/attachments/attachments.component';
import { PropertiesComponent } from './edit/properties/properties.component';
import { NewPropertyComponent } from './edit/properties/new-property/new-property.component';
import { ManagePropertyComponent } from './edit/properties/manage-property/manage-property.component';
import { EditPropertyComponent } from './edit/properties/edit-property/edit-property.component';
import { FloorPlanDialogComponent } from './edit/properties/edit-property/floorPlanDialog/floorPlanDialog.component';
import { PropertyItemComponent } from './edit/properties/manage-property/property-item/property-item.component';
import { HomeArComponent } from './project-detail/floorplans/home-ar/home-ar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgmCoreModule } from '@agm/core';
import { PropertyFpDialogComponent } from './project-detail/property-floor-plan-dialog/property-fp-dialog.component';
import { PropertyDocumentDialogComponent } from './project-detail/property-document-dialog/property-document-dialog.component';
import { DocumentDialogComponent } from './edit/properties/edit-property/documentDialog/documentDialog.component';
import { PermissionComponent } from './edit/permission/permission.component';
import { DeletePropertyDialogComponent } from './edit/properties/edit-property/deletePropertyDialog/deletePropertyDialog.component';
import { BuyerInfoComponent } from './edit/properties/edit-property/buyer-info/buyer-info.component';
import { BuyerChoiceComponent } from './edit/properties/edit-property/buyer-choice/buyer-choice.component';
import { AgencyInfoComponent } from './edit/properties/edit-property/agency-info/agency-info.component';
import { LawyerInfoComponent } from './edit/properties/edit-property/lawyer-info/lawyer-info.component';
import { BuyerInfoCreateComponent } from './edit/properties/edit-property/buyer-info/buyer-info-create/buyer-info-create.component';
import { BuyerInfoEditComponent } from './edit/properties/edit-property/buyer-info/buyer-info-edit/buyer-info-edit.component';
import { BuyerChoiceCreateComponent } from './edit/properties/edit-property/buyer-choice/buyer-choice-create/buyer-choice-create.component';
import { BuyerChoiceEditComponent } from './edit/properties/edit-property/buyer-choice/buyer-choice-edit/buyer-choice-edit.component';
import { LawyerInfoCreateComponent } from './edit/properties/edit-property/lawyer-info/lawyer-info-create/lawyer-info-create.component';
import { LawyerInfoUnlinkComponent } from './edit/properties/edit-property/lawyer-info/lawyer-info-unlink/lawyer-info-unlink.component';
import { BuyerInfoUnlinkComponent } from './edit/properties/edit-property/buyer-info/buyer-info-unlink/buyer-info-unlink.component';
import { PropertySelectionComponent } from './edit/properties/edit-property/property-selection/property-selection.component';
import { BuyerChoiceDeleteComponent } from './edit/properties/edit-property/buyer-choice/buyer-choice-delete/buyer-choice-delete.component';
import { PackagesComponent } from './edit/packages/packages.component';
import { LotComponent } from './edit/lot/lot.component';
import { ManageLotComponent } from './edit/lot/manage-lot/manage-lot.component';
import { NewLotComponent } from './edit/lot/new-lot/new-lot.component';
import { EditLotComponent } from './edit/lot/edit-lot/edit-lot.component';
import { DeleteLotDialogComponent } from './edit/lot/edit-lot/deleteLotDialog/deleteLotDialog.component';
import { NewPackagesComponent } from './edit/packages/new-packages/new-packages.component';
import { EditPackageComponent } from './edit/packages/edit-package/edit-package.component';
import { ImagePackageComponent } from './edit/packages/image-package/image-package.component';
import { FloorplanPackageComponent } from './edit/packages/floorplan-package/floorplan-package.component';
import { PropertyPackageComponent } from './edit/packages/property-package/property-package.component';
import { LinkLotComponent } from './edit/packages/link-lot/link-lot.component';
import { LinkPackageComponent } from './edit/lot/edit-lot/link-package/link-package.component';
import { StatusDialogComponent } from './edit/permission/status-dialog/status-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditPackagePropertyDialogComponent } from './edit/packages/property-package/edit-package-property-dialog/edit-package-property-dialog.component';
import { PropertyTagsComponent } from './edit/properties/edit-property/property-tags/property-tags.component';
import { SwiperModule } from 'swiper/angular';
import { PropertyInclusionsComponent } from './edit/properties/edit-property/property-inclusions/property-inclusions.component';
import { ProjectAnalyticsComponent } from './project-analytics/project-analytics.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ArModelComponent } from './edit/floor-plan/ar-model/ar-model.component';
import { NewArModelComponent } from './edit/floor-plan/ar-model/new-ar-model/new-ar-model.component';
import { ProjectCooperationComponent } from './project-cooperation/project-cooperation.component';
import { CommissionSettingsComponent } from './commission-settings/commission-settings.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxCurrencyModule } from 'ngx-currency';
import { CustomerContactComponent } from './customer-contact/customer-contact.component';
import { ManualUpdateDialogComponent } from './project-detail/manual-update-dialog/manual-update-dialog.component';
import { PhotoDialogComponent } from './project-detail/photo-dialog/photo-dialog.component';
import { VideoDialogComponent } from './project-detail/video-dialog/video-dialog.component';
import { PropertiesComponent as DetailPropertiesComponent } from './project-detail/properties/properties.component';
import { PropertyDetailDialogComponent } from './project-detail/properties/property-detail-dialog/property-detail-dialog.component';
import { AddPropertyDialogComponent } from './project-detail/properties/add-property-dialog/add-property-dialog.component';
import { UpdatePropertyStatusDialogComponent } from './project-detail/properties/update-property-status-dialog/update-property-status-dialog.component';
import { ArPreviewDialogComponent } from './project-detail/floorplans/ar-preview-dialog/ar-preview-dialog.component';
import { FloorplansComponent as DetailFloorplansComponent } from './project-detail/floorplans/floorplans.component';
import { EditFloorplanDialogComponent } from './project-detail/floorplans/edit-floorplan-dialog/edit-floorplan-dialog.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ConnectPropertyDialogComponent } from './project-detail/floorplans/connect-property-dialog/connect-property-dialog.component';
import { LotsComponent as DetailLotsComponent } from './project-detail/lots/lots.component';
import { AddLotDialogComponent } from './project-detail/lots/add-lot-dialog/add-lot-dialog.component';
import { LotDetailDialogComponent } from './project-detail/lots/lot-detail-dialog/lot-detail-dialog.component';
import { UpdateLotStatusDialogComponent } from './project-detail/lots/update-lot-status-dialog/update-lot-status-dialog.component';
import { DocumentsComponent } from './project-detail/documents/documents.component';
import { AddDocumentDialogComponent } from './project-detail/documents/add-document-dialog/add-document-dialog.component';
import { DeleteConfirmDialogComponent as DocumentDeleteConfirmDialogComponent } from './project-detail/documents/delete-confirm-dialog/delete-confirm-dialog.component';
import { SettingsComponent } from './project-detail/settings/settings.component';
import { PropertyStatusComponent } from './project-detail/properties/property-status/property-status.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { DeleteConfirmDialogComponent as FloorplanDeleteConfirmDialogComponent } from './project-detail/floorplans/delete-confirm-dialog/delete-confirm-dialog.component';
import { EoisComponent } from './project-detail/eois/eois.component';
import { AllocateDialogComponent } from "./project-detail/properties/allocate-dialog/allocate-dialog.component";
import { MatChipsModule } from "@angular/material/chips";
import { NgSelectModule } from "@ng-select/ng-select";
import { RejectDialog } from "./project-cooperation/reject-dialog/reject-dialog";
import { AgenciesLog } from "./project-cooperation/agencies-log/agencies-log";
import { AddEoi } from "./project-detail/eois/add-eoi/add-eoi";
import { NgxFileDropModule } from "ngx-file-drop";
import { SuccessDialogComponent } from "./project-detail/eois/add-eoi/success-dialog/success-dialog.component";
import { EoiDetail } from "./project-detail/eois/eoi-detail/eoi-detail";
import { ButtonDialogComponent } from "./project-detail/eois/eoi-detail/button-dialog/button-dialog.component";
import { ProgressComponent } from "./project-detail/eois/add-eoi/progress/progress.component";
import { SearchForm } from "./project-detail/eois/search-form/search-form";
import { AddProjectDialogComponent } from './add-project-dialog/add-project-dialog.component'
import {EoiDetailDialog} from "./project-detail/eois/eoi-detail-dialog/eoi-detail-dialog"
import {AddEoiDialog} from './project-detail/eois/add-eoi-dialog/add-eoi-dialog'
import {FlexModule} from "@angular/flex-layout";
import {MatIconModule} from "@angular/material/icon";
import {TooltipModule} from "../../shared/components/tooltip";

/**
 * @class ProjectModule
 * @memberOf RoutesRoutingModule
 * @description This is a module which included all the components of project section. It has been used in RoutesRoutingModule
 */
const COMPONENTS = [
    NewProjectComponent,
    ProjectDetailComponent,
    BasicInfoComponent,
    PermissionComponent,
    PackagesComponent,
    EditProjectComponent,
    PicturesComponent,
    FloorPlanComponent,
    AttachmentsComponent,
    PropertiesComponent,
    LotComponent,
    ManageLotComponent,
    NewLotComponent,
    EditLotComponent,
    NewPropertyComponent,
    ManagePropertyComponent,
    EditPropertyComponent,
    PropertyItemComponent,
    HomeArComponent,
    BuyerInfoComponent,
    BuyerChoiceComponent,
    AgencyInfoComponent,
    LawyerInfoComponent,
    PropertySelectionComponent,
    // PropertyDocumentDialogComponent
    PropertyTagsComponent,
    PropertyInclusionsComponent,
    ArModelComponent,
    NewArModelComponent,
    CommissionSettingsComponent,
    RejectDialog,
    CustomerContactComponent,
    DetailPropertiesComponent,
    DetailFloorplansComponent,
    ConnectPropertyDialogComponent,
    DetailLotsComponent,
    ProjectCooperationComponent,
    AgenciesLog,
    ProjectAnalyticsComponent,
    DocumentsComponent,
    SettingsComponent,
    PropertyStatusComponent,
    EoisComponent,
    AddEoi,
    EoiDetail,
    ProgressComponent,
    SearchForm
];

const COMPONENTS_DYNAMIC = [
    StatusDialogComponent,
    FloorPlanDialogComponent,
    DocumentDialogComponent,
    PropertyFpDialogComponent,
    PropertyDocumentDialogComponent,
    DeletePropertyDialogComponent,
    DeleteLotDialogComponent,
    BuyerInfoCreateComponent,
    BuyerInfoEditComponent,
    BuyerInfoUnlinkComponent,
    BuyerChoiceCreateComponent,
    BuyerChoiceEditComponent,
    BuyerChoiceDeleteComponent,
    LawyerInfoCreateComponent,
    LawyerInfoUnlinkComponent,
    NewPackagesComponent,
    EditPackageComponent,
    ImagePackageComponent,
    FloorplanPackageComponent,
    PropertyPackageComponent,
    LinkLotComponent,
    LinkPackageComponent,
    EditPackagePropertyDialogComponent,
    ManualUpdateDialogComponent,

    PhotoDialogComponent,
    VideoDialogComponent,
    PropertyDetailDialogComponent,
    AddPropertyDialogComponent,
    AllocateDialogComponent,
    UpdatePropertyStatusDialogComponent,
    ArPreviewDialogComponent,
    EditFloorplanDialogComponent,
    AddLotDialogComponent,
    LotDetailDialogComponent,
    UpdateLotStatusDialogComponent,
    AddDocumentDialogComponent,
    DocumentDeleteConfirmDialogComponent,
    FloorplanDeleteConfirmDialogComponent,
    SuccessDialogComponent,
    ButtonDialogComponent,
    AddProjectDialogComponent,
    EoiDetailDialog,
    AddEoiDialog
];

@NgModule({
    imports: [SharedModule, ProjectRoutingModule, ReactiveFormsModule, MatTooltipModule, AgmCoreModule, DragDropModule, SwiperModule, MatProgressBarModule, MatSlideToggleModule, NgxCurrencyModule, NgxDropzoneModule, MatGridListModule, MatChipsModule, NgSelectModule, NgxFileDropModule, FlexModule, MatIconModule, TooltipModule, TooltipModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC],
    exports: [...COMPONENTS],
    entryComponents: COMPONENTS_DYNAMIC,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    // providers: [UsersManagerService]
})

export class ProjectModule {
}
